import {
  pipe,
  propOr,
  ifElse,
  complement,
  path,
  isNil,
  always,
  replace,
  trim,
  map,
  filter,
  anyPass,
  isEmpty,
  split,
  startsWith,
  divide,
  __,
  cond,
  applySpec,
  T
} from 'ramda'

const imageGalleryUrl = path([
  'imageGallery',
  'fields',
  'imageGalleryItem',
  0,
  'fields',
  'image',
  'fields',
  'file',
  'url'
])

const imageUrl = path(['image', 'fields', 'file', 'url'])

const imageGalleryAlt = path([
  'imageGallery',
  'fields',
  'imageGalleryItem',
  0,
  'fields',
  'imageTitle'
])

const imageAlt = path(['image', 'fields', 'title'])

const imagesUrl = path(['images', 0, 'fields', 'file', 'url'])

const imagesAlt = path(['images', 0, 'fields', 'title'])

export const getCartChangeURL = (changeUrl, displayName) => {
  const productNameForAnalytics = displayName.replace(/ /g, '_')
  const linktypePrefix = changeUrl.includes('?') ? '&' : '?'
  const changeUrlLink = `${changeUrl}${linktypePrefix}linktype=changeitem_${productNameForAnalytics}`
  return changeUrlLink
}

export const getImageUrlAndAltText = pipe(
  propOr({}, 'content'),
  cond([
    [
      pipe(imageGalleryUrl, complement(isNil)),
      applySpec({
        imageUrl: imageGalleryUrl,
        imageAlt: imageGalleryAlt
      })
    ],
    [pipe(imageUrl, complement(isNil)), applySpec({ imageUrl, imageAlt })],
    [pipe(imagesUrl, complement(isNil)), applySpec({ imageUrl: imagesUrl, imageAlt: imagesAlt })],
    [T, () => ({ imageUrl: '', imageAlt: '' })] // Futureproof - add placeholder image and alt text here when images/alt are not available
  ])
)

export const splitMessages = pipe(
  ifElse(
    anyPass([isEmpty, isNil]),
    always([]),
    pipe(
      trim,
      ifElse(startsWith('* '), split('* '), split('- ')),
      filter(complement(isEmpty)),
      map(pipe(replace('\n', ''), trim))
    )
  )
)

export const getCheckoutDescription = pipe(path(['content', 'checkoutDescription']), splitMessages)

export const getTermInYears = pipe(path(['contractTerm', 'recurringDuration']), divide(__, 12))

export const getTermInMonths = (offer) => getTermInYears(offer) * 12
